/**
 * Il pannello delle impostazioni di un modulo: pagina intera sopra il modulo,
 * con una via d'uscita sola e visibile.
 *
 * Era dentro Spedizioni; dal 27-08-2026 è condiviso, perché la Pianificazione ha
 * smesso di avere le Impostazioni come tab (decisione di Enrico: le manopole non
 * stanno in fila con le sezioni di lavoro). Due copie dello stesso guscio
 * sarebbero tornate a divergere, come è già successo alle due chat degli agenti.
 *
 * `top-14` e non `inset-0`: l'header del portale resta visibile, così si sa
 * sempre in quale modulo si sta configurando qualcosa.
 */
import { Settings, X } from "lucide-react";

export function ImpostazioniOverlay({
  titolo = "Impostazioni del modulo",
  onChiudi,
  children,
}: {
  titolo?: string;
  onChiudi: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="fixed inset-0 top-14 z-40 overflow-y-auto bg-background">
      <div className="mx-auto max-w-7xl px-6 py-6">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-lg font-bold">
            <Settings className="h-5 w-5 text-brand-700" /> {titolo}
          </h2>
          <button
            type="button"
            onClick={onChiudi}
            className="inline-flex items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            <X className="h-4 w-4" /> Chiudi
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
